import { DateTime } from 'luxon';
import { schema } from 'normalizr';
import { LuxonFormats, PatientChartInfo } from 'types';

export const physician = new schema.Entity('physicians');
export const appointmentType = new schema.Entity('appointmentTypes');
export const schedule = new schema.Entity('schedules');
export const chart = new schema.Entity(
  'charts',
  {},
  {
    processStrategy: (entity: Partial<PatientChartInfo>): Partial<PatientChartInfo> => {
      return {
        ...entity,
        dob: DateTime.fromISO(entity.dob).toFormat(LuxonFormats.UserFacingDob),
      };
    },
  },
);
export const patient = new schema.Entity('patients', { charts: [chart] });

export const practice = new schema.Entity('practices', {
  appointmentTypes: [appointmentType],
  physicians: [physician],
  schedule,
});

export const appointment = new schema.Entity('appointments', {
  patient: chart,
  apptType: appointmentType,
  physician,
  practice,
});
